var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.reasons),function(reason,index){return _c('div',{key:`reason-${reason}-${index}`,staticClass:"mr-2"},[_c('ExplainabilityBadge',{attrs:{"title":reason}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }